var REPLACE_STATE_DELAY_MS = 800;

document.addEventListener('submit', function(evt) {
  var form = evt.target;
  if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
  var bundleUrl = form.getAttribute('data-bundle-product-url');
  var isBundleVariant = form.getAttribute('data-is-bundle-variant') === 'true';
  var path = window.location.pathname;
  if (!bundleUrl || !isBundleVariant || path.indexOf('2026-ultimate-editing-pack') === -1) return;
  var savedUrl = window.location.href;
  history.replaceState(null, '', bundleUrl);
  form.setAttribute('data-selleasy-saved-url', savedUrl);
}, true);

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              document.dispatchEvent(
                new CustomEvent('cart:item-added', {
                  detail: {
                    variantId: formData.get('id'),
                    cartData: response,
                    source: this.closest('quick-add-modal') ? 'quick-add' : 'product-form',
                  },
                  bubbles: true,
                })
              );
              var savedUrl = this.form.getAttribute('data-selleasy-saved-url');
              if (savedUrl) {
                setTimeout(function() {
                  history.replaceState(null, '', savedUrl);
                }, REPLACE_STATE_DELAY_MS);
                this.form.removeAttribute('data-selleasy-saved-url');
              }
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            var self = this;
            var doRender = function () { self.cart.renderContents(response); };
            var defer = window.requestIdleCallback ? function (fn) { window.requestIdleCallback(fn, { timeout: 300 }); } : function (fn) { setTimeout(fn, 0); };
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                function () { defer(function () { self.cart.renderContents(response); }); },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              defer(doRender);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
